import { render } from "./EndView.vue?vue&type=template&id=8d1563a4&scoped=true"
import script from "./EndView.vue?vue&type=script&lang=js"
export * from "./EndView.vue?vue&type=script&lang=js"

import "./EndView.vue?vue&type=style&index=0&id=8d1563a4&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d1563a4"]])

export default __exports__